import LoginShell from "./_LoginShell";

export default function AdminLogin() {
  return (
    <LoginShell
      title="Area Riservata"
      subtitle="Accedi al CMS Magniflex con le tue credenziali interne."
      role="admin"
      redirect="/admin"
      testid="admin-login-page"
      otherRoleHref="/hotel/login"
      otherRoleLabel="Sei staff di un hotel? Accedi al portale"
    />
  );
}
